module.exports = __webpack_public_path__ + "static/media/ehealth-bg2-16-9.a020666f.jpg";